module.exports = "/_next/static/images/483df4202bf4e1040593525ede220806-defer-lg.png";